import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css, keyframes } from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { Container as ButtonContainer } from "./Container";
export const HoverAnimation = props => {
  const {
    children,
    variant
  } = props;
  if (!variant.startsWith("anim-")) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Content, props), /*#__PURE__*/React.createElement(Clone, _extends({
    "aria-hidden": true
  }, props)));
};
const backwardDuration = "1s";
const forwardDuration = "1s";
const upDuration = "0.75s";
const easeOutExp = "cubic-bezier(0.16, 1, 0.3, 1)";
const easeOutQuad = "cubic-bezier(0.45, 0, 0.55, 1)";
const up = keyframes(["0%{opacity:1;}40%,100%{opacity:0;}"]);
const upClone = keyframes(["0%{opacity:0;}40%,100%{opacity:1;}"]);
const forward = keyframes(["0%{opacity:1;transform:translateX(0);}25%{opacity:0;}100%{opacity:0;transform:translateX(100%);}"]);
const forwardClone = keyframes(["0%{opacity:0;transform:translateX(-100%);}25%{opacity:0;}50%{opacity:1;}100%{opacity:1;transform:translateX(0);}"]);
const backward = keyframes(["0%{opacity:1;transform:translateX(0);}25%{opacity:0;}100%{opacity:0;transform:translateX(-100%);}"]);
const backwardClone = keyframes(["0%{opacity:0;transform:translateX(100%);}25%{opacity:0;}50%{opacity:1;}100%{opacity:1;transform:translateX(0);}"]);
const delay = _ref => {
  let {
    delay
  } = _ref;
  return delay;
};
const Container = styled.span.withConfig({
  displayName: "HoverAnimation__Container"
})(["height:100%;position:relative;"]);
const Content = styled.span.withConfig({
  displayName: "HoverAnimation__Content"
})(["align-items:center;display:flex;height:100%;transition-delay:0;transition-duration:0;transition-property:transform;transition-timing-function:", ";", ":not([disabled]):hover &&{", "}"], easeOutExp, ButtonContainer, tombac.variant("variant", {
  "anim-backward": css(["animation:", " ", " ", " ", " infinite;"], backward, backwardDuration, easeOutExp, delay),
  "anim-forward": css(["animation:", " ", " ", " ", " infinite;"], forward, forwardDuration, easeOutExp, delay),
  "anim-up": css(["animation:", " ", " ", " ", " forwards;transform:translateY(-40%);transition-delay:", ";transition-duration:0.75s;"], up, upDuration, easeOutQuad, delay, delay)
}));
const Clone = styled(Content).withConfig({
  displayName: "HoverAnimation__Clone"
})(["display:flex;left:0;opacity:0;position:absolute;top:0;transform:translateY(40%);", ":not([disabled]):hover &&{", "}", ""], ButtonContainer, tombac.variant("variant", {
  "anim-backward": css(["animation:", " ", " ", " ", " infinite;"], backwardClone, backwardDuration, easeOutExp, delay),
  "anim-forward": css(["animation:", " ", " ", " ", " infinite;"], forwardClone, forwardDuration, easeOutExp, delay),
  "anim-up": css(["animation:", " ", " ", " ", " forwards;transform:translateY(0);"], upClone, upDuration, easeOutQuad, delay)
}), propStyling);
//# sourceMappingURL=HoverAnimation.js.map